import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  walletId: 0,
  wallet:null,
  previousWalletId:null,
  daysLeft:0,
  isPremium:false,
  membershipDate:null,
  symbolLimit:11,
  blinkWallet:false,
  paymentType:'',
  ethSnapshotPrice:0.0,
  solSnapshotPrice:0.0,
  webWalletApp:'',
  email:'',
  walletErrorMsg:'',
  isAdmin:false
};

const globalDataSlicer = createSlice({
  name: 'globalData',
  initialState,
  reducers: {
    setWalletId: (state, action) => {
      state.walletId = action.payload;
    },
    setWallet: (state, action) => {
      state.wallet = action.payload;
    },
    setPreviousWalletId: (state, action) => {
      state.previousWalletId = action.payload;
    },
    setDaysLeft: (state, action) => {
      state.daysLeft = action.payload;
    },
    setIsPremium: (state, action) => {
      state.isPremium = action.payload;
    },
    setMembershipDate: (state, action) => {
      state.membershipDate = action.payload;
    },
    setSymbolLimit: (state, action) => {
      state.symbolLimit = action.payload;
    },
    setBlinkWallet: (state, action) => {
      state.blinkWallet = action.payload;       
    },
    setPaymentType: (state, action) => {
      state.paymentType = action.payload;       
    },
    setEthSnapshotPrice: (state, action) => {
      state.ethSnapshotPrice = action.payload;       
    },
    setSolSnapshotPrice: (state, action) => {
      state.solSnapshotPrice = action.payload;       
    },
    setWebWalletApp: (state, action) => {
      state.webWalletApp = action.payload;       
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setWalletErrorMsg: (state, action) => {
      state.walletErrorMsg = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
  }
});

export const { setWalletId, setWallet, setDaysLeft, setIsPremium, setMembershipDate, 
  setSymbolLimit, setPreviousWalletId, setBlinkWallet, setPaymentType, setEthSnapshotPrice,
  setSolSnapshotPrice, setWebWalletApp, setEmail, setWalletErrorMsg, setIsAdmin } = globalDataSlicer.actions;
export default globalDataSlicer.reducer;

